import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { checkStoreState, setInitialStoreState } from '../../../../../common/utils';
import { TransportManagementProfileItemBriefFacade } from './transport-management-profile-item-brief.facade';

@Injectable({
  providedIn: 'root',
})
export class TransportManagementProfileItemBriefGuard {
  constructor(private transportManagementProfileItemBriefFacade: TransportManagementProfileItemBriefFacade) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    const {
      params: { transportManagementProfileId },
    } = route;

    return checkStoreState(this.transportManagementProfileItemBriefFacade, transportManagementProfileId);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.transportManagementProfileItemBriefFacade);
  }
}
